<template>
  <main class="container error-page text-center">
    <EmptyState title="You don’t have access to this." description="Ask the list owner for an invite if you think you should be here.">
      <template #action>
        <router-link class="btn btn-yellow" :to="{ name: 'Lists' }">Back to your lists</router-link>
      </template>
    </EmptyState>
  </main>
</template>

<script>
import EmptyState from "@/components/EmptyState.vue";

export default {
  name: "ForbiddenView",
  components: {
    EmptyState,
  },
};
</script>

<style scoped>
.error-page {
  min-height: calc(100vh - 56px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-page :deep(.empty-state) {
  width: 100%;
  color: #f5f6f4;
}
</style>
